import { combineEpics } from "redux-observable";
import { AsyncActionRequestEpicCreator } from "./async-action/asyncActionRequestEpicCreator.js";
import { ProtectEpicCreator } from "./error-handling/protectEpicCreator.js";
class BaseEpicsBuilder {
  _asyncEpicCreator;
  _protectEpicCreator;
  constructor() {
    this._asyncEpicCreator = new AsyncActionRequestEpicCreator();
    this._protectEpicCreator = new ProtectEpicCreator();
  }
  buildEpics() {
    const epics = this.buildEpicList();
    return epics.length === 1 ? this._protectEpicCreator.createEpic(epics[0]) : combineEpics(...epics.map((epic) => this._protectEpicCreator.createEpic(epic)));
  }
  buildRequestEpic(asyncAction, callback, shouldCancelPreviousAction = true) {
    return this._asyncEpicCreator.createRequestEpic(asyncAction, callback, shouldCancelPreviousAction);
  }
}
export {
  BaseEpicsBuilder
};
//# sourceMappingURL=epicsBuilder.js.map
